/**
 * Node Modules
 */
import React from 'react'

/**
 * Application Modules
 */
import './style.css'

/**
 * Component
 */
export default function Grid({ className, children }) {
  return <div className={className + ' grid grid--spaced'}>{children}</div>
}
